// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

//   React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

//   React context
import {useMaterialUIController} from "context";
import {Grid, Typography} from "@mui/material";
import properties from "constants/ApplicationConstants";

function Bill({
  empId,
  username,
  firstName,
  middleName,
  lastName,
  gender,
  maritalStatus,
  birthDate,
  emailAddress,
  mobileNo,
  alterMobileNo,
  emergencyContact,
  emergencyRelation,
  nameRelation,
  emegencyAddressLine1,
  pfUanNo,
  prevPfNo,
  bntPfNo,
  pancardNo,
  nameInPancard,
  education,
  speciallyAbled,
  speciallyAbledCategory,
  fatherName,
  noGutter
}) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;

  return (
    <MDBox
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor={darkMode ? "transparent" : "grey-100"}
      borderRadius="lg"
      p={1}
      mb={noGutter ? 0 : 1}
      mt={1}
    >
      <MDBox width="100%" display="flex" flexDirection="column">
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                First Name :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  textTransform="capitalize"
                  fontFamily={properties.fontFamily}
                >
                  {firstName ? firstName : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" mr={2} fontFamily={properties.fontFamily}>
                Middle Name :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {middleName ? middleName : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Last Name :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {lastName ? lastName : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>
        </Grid>

        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Gender :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  textTransform="capitalize"
                  fontFamily={properties.fontFamily}
                >
                  {gender ? gender : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" mr={2} fontFamily={properties.fontFamily}>
                Marital Status :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {maritalStatus ? maritalStatus : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Date of Birth :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {birthDate ? birthDate : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>
        </Grid>

        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Email :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {emailAddress ? emailAddress : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" mr={2} fontFamily={properties.fontFamily}>
                Mobile :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {mobileNo ? mobileNo : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Alternate No. :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {alterMobileNo ? alterMobileNo : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>
        </Grid>

        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Emergency contact No :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {emergencyContact ? emergencyContact : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" mr={2} fontFamily={properties.fontFamily}>
                Name of the person :&nbsp;
                <Typography
                  variant="outlined"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {nameRelation ? nameRelation : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Relation :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {emergencyRelation ? emergencyRelation : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>
        </Grid>

        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Emergency person&apos;s Address :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {emegencyAddressLine1 ? emegencyAddressLine1 : "NA"}
                </Typography>
              </Typography>
              {/* </MDBox>
          <MDBox mb={1} lineHeight={0} ml={0}>
            <MDTypography variant="caption" color="text" mr={2}>
            Name of the person :&nbsp;
              <MDTypography variant="outlined" fontWeight="medium">
                {reportTo?reportTo:'NA'}
              </MDTypography>
            </MDTypography> */}
            </MDBox>
          </Grid>
        </Grid>

        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                UAN :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {pfUanNo ? pfUanNo : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Prev PF No. :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {prevPfNo ? prevPfNo : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" mr={2} fontFamily={properties.fontFamily}>
                BNT PF No. :&nbsp;
                <Typography
                  variant="outlined"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {bntPfNo ? bntPfNo : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>
        </Grid>

        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                PAN Card No :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {pancardNo ? pancardNo : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Name in PAN Card :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {nameInPancard ? nameInPancard : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" mr={2} fontFamily={properties.fontFamily}>
                Education :&nbsp;
                <Typography
                  variant="outlined"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {education ? education : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>
        </Grid>

        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Specially Abled :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {speciallyAbled ? speciallyAbled : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Specially Abled Category :&nbsp;
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {speciallyAbledCategory ? speciallyAbledCategory : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" mr={2} fontFamily={properties.fontFamily}>
                Father Name :&nbsp;
                <Typography
                  variant="outlined"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                >
                  {fatherName ? fatherName : "NA"}
                </Typography>
              </Typography>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

Bill.defaultProps = {
  noGutter: false
};

Bill.propTypes = {
  name: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  vat: PropTypes.string.isRequired,
  noGutter: PropTypes.bool
};

export default Bill;
